<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :search="search"
      :fixed-header="true"
      item-key="id"
      class="elevation-2 table-acl-resposivo"
      :item-class="corlinha"
      :items-per-page="-1"
    >
      <template #top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Cadastro de Usuários</v-toolbar-title>
          <p
            v-show="licencas.licencas > 0 && licencas.qtd_ativos > 0"
            class="ma-0 font-13 ml-1 mt-1"
            v-text="`- Licenças: ${licencas.qtd_ativos}/${licencas.licencas}`">

          </p>

          <v-spacer></v-spacer>

          <v-text-field
            class="mr-4"
            v-model="search"
            outlined
            dense
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>

          <v-dialog persistent v-model="dialog" max-width="700px" content-class="bra-20">
            <template #activator="{ on }">
              <v-btn color="primary" dark v-on="on">Novo</v-btn>
            </template>

            <v-card>
              <v-card-title class="mb-3">
                <span class="font-20 font-weight-medium">{{ formTitle }}</span>

                <v-spacer />

                <v-btn
                  color="#000"
                  icon
                  style="margin-left: -10px"
                  @click="close()"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <v-card-text class="d-flex align-center mb-6">
                <v-container>
                  <v-row>
                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.name"
                        label="Nome Completo*"
                        autofocus
                        :error-messages="nameErrors"
                        @input="$v.editedItem.name.$touch()"
                        @blur="$v.editedItem.name.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.email"
                        label="Email*"
                        :error-messages="emailErrors"
                        @input="$v.editedItem.email.$touch()"
                        @blur="
                          $v.editedItem.email.$touch();
                          verificaUsoEmail();
                        "
                        @keypress="errors.usuario.email.jaExiste = null"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="6" xs="6">
                      <v-select
                        v-model="editedItem.idperfil"
                        :items="selects.perfil.items"
                        chips
                        label="Perfil do Sistema"
                        height="15"
                        outlined
                        item-value="idperfil"
                        item-text="descricao_perfil"
                        :error-messages="perfilErrors"
                        @input="$v.editedItem.idperfil.$touch()"
                        @blur="$v.editedItem.idperfil.$touch()"
                      ></v-select>
                    </v-col>
                    <v-col class="pa-0 pl-5" cols="6">
                      <v-text-field
                        outlined
                        v-model="editedItem.setor"
                        label="Setor*"
                        item-text="descricao_perfil"
                        :error-messages="setorErrors"
                        @input="$v.editedItem.setor.$touch()"
                        @blur="$v.editedItem.setor.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col v-if="editedIndex === -1" class="pa-0" cols="6" xs="6">
                      <v-text-field
                        outlined
                        v-model="editedItem.password"
                        label="Nova Senha*"
                        :error-messages="passwordErrors"
                        type="password"
                        autocomplete="new-password"
                        @input="$v.editedItem.password.$touch()"
                        @blur="$v.editedItem.password.$touch()"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      v-if="editedIndex === -1"
                      class="pa-0 pl-5"
                      cols="6"
                      xs="6"
                    >
                      <v-text-field
                        outlined
                        v-model="editedItem.repeatPassword"
                        label="Confirma Senha*"
                        :error-messages="repeatPasswordErrors"
                        type="password"
                        @input="$v.editedItem.repeatPassword.$touch()"
                        @blur="$v.editedItem.repeatPassword.$touch()"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="6" xs="6">
                      <v-select
                        v-model="editedItem.visao_gerencial"
                        :items="selects.visaoGerencial.items"
                        chips
                        label="Visão Gerencial"
                        height="10"
                        outlined
                        item-value="id"
                        item-text="descricao"
                        style="margin-right: 5px"
                        :error-messages="visaoGerencial"
                        @input="$v.editedItem.visao_gerencial.$touch()"
                        @blur="$v.editedItem.visao_gerencial.$touch()"
                      ></v-select>
                    </v-col>
                    <v-col class="pa-0 pl-5" cols="6" xs="6">
                      <v-text-field
                        v-model="editedItem.cod_sistema"
                        label="Código do Sistema"
                        outlined
                        :error-messages="Cod_SistemaErrors"
                        @input="$v.editedItem.cod_sistema.$touch()"
                        @blur="$v.editedItem.cod_sistema.$touch()"
                      ></v-text-field>
                    </v-col>

                    <v-col class="pa-0" cols="6" xs="6">
                      <v-select
                        v-model="editedItem.visualizar_inicio_cotacao"
                        :items="selects.visaoGerencial.items"
                        chips
                        label="Visualizar Início Cotação"
                        height="10"
                        outlined
                        item-value="id"
                        item-text="descricao"
                        style="margin-right: 5px"
                        :error-messages="visualizarInicioCotacaoErrors"
                        @input="$v.editedItem.visualizar_inicio_cotacao.$touch()"
                        @blur="$v.editedItem.visualizar_inicio_cotacao.$touch()"
                      ></v-select>
                    </v-col>

                    <v-col class="pa-0 pl-5" cols="6" xs="6"></v-col>

                    <v-col class="pa-0" cols="12" xs="12">
                      <v-switch
                        v-model="editedItem.bloquear_hist_faturamento"
                        inset
                        label="Bloquear Histograma"
                      />
                    </v-col>

                    <v-col class="pa-0" cols="6" xs="6" v-if="editedIndex != -1">
                      <v-btn
                        color="warning"
                        dark
                        style="margin-bottom: 10px"
                        @click="resetarSenha()"
                      >
                        <v-icon>mdi-lock-reset</v-icon>
                        RESETAR SENHA
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions style="margin-top: -40px">
                <v-spacer />

                <v-btn color="blue darken-1" text @click="save()">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <ativa-ou-desativa
            v-model="dialogAtivaDesativa"
            :usuario="editedItem"
            @licencas-esgotadas="ev => dialogError = ev"
            @estado-ativacao-usuario-alterado="initialize();totalLicencas();"
            @change-dialog="editedItem = {}"
          />
        </v-toolbar>
      </template>
      <template #item.action="{ item }">
        <div class="d-flex align-center">
          <ResetarSenhaUsuario :usuario="item" />

          <v-btn
            icon
            class="ml-n1"
            :title="`${item.ativo === 'N' ? 'Ativar ' : 'Desativar '} Usuário`"
            :color="item.ativo === 'N' ? 'red' : 'green'"
            @click="abrirDialogDesativacaoUsuario(item)"
          >
            <v-icon>{{ item.ativo === "N" ? "mdi-lock" : "mdi-lock-open-variant" }}</v-icon>
          </v-btn>

          <v-btn
            icon
            class="ml-n1"
            title="Editar Usuário"
            @click="editItem(item)"
            :disabled="item.ativo === 'N'"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn class="ml-n1" icon title="Remover Usuário" @click="deleteItem(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <dialog-error :dialog="dialogError.ativo" :errors="dialogError.mensagem" @fechar="dialogError.ativo = false" />
  </div>
</template>

<script>
import {
  required,
  email,
  sameAs,
  minLength
} from "vuelidate/lib/validators";
import UsuarioAPI from "./../../api/usuario";
import AtivaOuDesativa from "./AtivaOuDesativa";
import DialogError from '../utils/DialogError.vue';
import ResetarSenhaUsuario from "@/components/auth/ResetarSenhaUsuario";

export default {
  props: ["atualizarUsu", "filtrar_admin"],
  name: "Acl",
  components: {
    ResetarSenhaUsuario,
    AtivaOuDesativa,
    DialogError
  },
  data: () => ({
    dialog: false,
    search: "",
    dialogAtivaDesativa: false,
    licencas: {
      licencas: 0,
      qtd_ativos: 0,
    },
    headers: [
      { text: "ID", value: "id", width: "80px", align: "center" },
      { text: "Nome Completo", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "Setor", value: "setor" },
      { text: "Perfil", value: "descricao_perfil" },
      {
        text: "Visão Gerencial",
        value: "visao_gerencial",
        width: "103px",
        align: "center",
      },
      {
        text: "Visualizar Início Cotação",
        value: "visualizar_inicio_cotacao",
        width: "150px",
        align: "center",
      },
      { text: "Código do Sistema", value: "cod_sistema" },
      { text: "Último Acesso", value: "updated_at" },
      {
        text: "",
        value: "action",
        sortable: false,
        width: "100px",
        align: "center",
      },
    ],
    desserts: [],
    editedIndex: -1,
    selects: {
      perfil: {
        items: [],
      },
      visaoGerencial: {
        items: [
          { id: "S", descricao: "SIM" },
          { id: "N", descricao: "NÃO" },
        ],
      },
    },
    editedItem: {
      id: "",
      name: "",
      email: "",
      setor: "",
      idperfil: "",
      visao_gerencial: "",
      visualizar_inicio_cotacao: "N",
      cod_sistema: "",
      password: "",
      repeatPassword: "",
      ativo: "",
      bloquear_hist_faturamento: false
    },
    defaultItem: {
      id: "",
      name: "",
      email: "",
      setor: "",
      idperfil: "",
      visao_gerencial: "",
      visualizar_inicio_cotacao: "N",
      cod_sistema: "",
      password: "",
      repeatPassword: "",
      ativo: "",
    },
    errors: {
      usuario: {
        email: {
          jaExiste: false,
        },
      },
    },
    dialogError: {
      ativo: false,
      mensagem: []
    }
  }),

  validations: {
    editedItem: {
      name: {
        required,
        minLength() {
          if (this.editedItem.name.trim().length >= 2) return true;
          else return false;
        },
      },
      email: {
        required,
        email,
        jaExiste() {
          if (!this.errors.usuario.email.jaExiste) {
            return true;
          } else {
            return false;
          }
        },
        naoVerificado() {
          if (this.errors.usuario.email.jaExiste !== null) {
            return true;
          } else {
            return false;
          }
        },
      },
      setor: {
        required,
      },
      idperfil: {
        required,
      },
      visao_gerencial: {
        required,
      },
      visualizar_inicio_cotacao: {
        required,
      },
      password: {
        required,
        minLength: minLength(6),
      },
      repeatPassword: {
        sameAsPassword: sameAs("password"),
      },

      cod_sistema: {
        maxLenght() {
          if (this.editedItem.cod_sistema && this.editedItem.cod_sistema != 0) {
            return this.editedItem.cod_sistema.trim().length == 6;
          } else {
            return true;
          }
        },
      },
    },
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.editedItem.name.$dirty) return errors;
      !this.$v.editedItem.name.required && errors.push("Campo Obrigatório.");
      !this.$v.editedItem.name.minLength && errors.push("Nome deve ter mais de 5 caracteres.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email.$dirty) return errors;
      !this.$v.editedItem.email.email && errors.push("Email incorreto.");
      !this.$v.editedItem.email.required && errors.push("Campo Obrigatório.");
      !this.$v.editedItem.email.jaExiste &&
        errors.push("Email já está sendo usado por outro usuário.");
      return errors;
    },
    setorErrors() {
      const errors = [];
      if (!this.$v.editedItem.setor.$dirty) return errors;
      !this.$v.editedItem.setor.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    perfilErrors() {
      const errors = [];
      if (!this.$v.editedItem.idperfil.$dirty) return errors;
      !this.$v.editedItem.idperfil.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    visaoGerencial() {
      const errors = [];
      if (!this.$v.editedItem.visao_gerencial.$dirty) return errors;
      !this.$v.editedItem.visao_gerencial.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    visualizarInicioCotacaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.visualizar_inicio_cotacao.$dirty) return errors;
      !this.$v.editedItem.visualizar_inicio_cotacao.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.editedItem.password.$dirty) return errors;
      !this.$v.editedItem.password.minLength &&
        errors.push("A senha dever ser maior que 6 caracteres");
      !this.$v.editedItem.password.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.editedItem.repeatPassword.$dirty) return errors;
      !this.$v.editedItem.repeatPassword.sameAsPassword &&
        errors.push("As senhas devem ser iguais.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Novo Usúario" : "Editar Usuário";
    },
    Cod_SistemaErrors() {
      const errors = [];
      if (!this.$v.editedItem.cod_sistema.$dirty) return errors;
      !this.$v.editedItem.cod_sistema.maxLenght &&
        errors.push("O código deve conter 6 caracteres");
      return errors;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    atualizarUsu() {
      this.initialize();
    },
  },

  created() {
    this.initialize();
    this.totalLicencas();
  },

  methods: {
    totalLicencas() {
      const headers = this.Helpers.iniciarRequisicao()

      UsuarioAPI.getLicencasUsuarios(headers)
        .then((response) => {
          const {token, licencas} = response.data;
          localStorage.setItem("token", token);
          this.licencas = licencas;
        })
    },

    abrirDialogDesativacaoUsuario(item) {
      this.dialogAtivaDesativa = true;
      this.editedItem = Object.assign({}, item);
    },

    corlinha(item) {
      return { 'text-red': item.ativo == "N" };
    },

    verificaUsoEmail() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = this.editedItem;

      UsuarioAPI.verificaUsoEmail(headers, params)
        .then((response) => {
          const { token, existe } = response.data;
          localStorage.setItem("token", token);

          if (existe) {
            this.errors.usuario.email.jaExiste = true;
            this.$v.email.$touch();
          } else {
            this.errors.usuario.email.jaExiste = false;
            this.$v.email.$touch();
          }
        })
        .catch(() => {
          // this.Helpers.logout();
        });
    },

    resetarSenha() {
      if (
        confirm(
          "Deseja Realmente RESETAR a senha do usuário?\n\nSenha após reset: 123456"
        )
      ) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = { id: this.editedItem.id };

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.resetarSenha(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.dialog = false;
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        filtrar_admin: this.filtrar_admin ? "S" : "N",
      };

      UsuarioAPI.getPerfis(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.perfil.items = response.data.perfis;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      UsuarioAPI.getUsuarios(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.desserts = response.data.usuarios;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      this.$store.dispatch("loading/habilitarLoading", false);
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (!this.editedItem.visualizar_inicio_cotacao) {
        this.editedItem.visualizar_inicio_cotacao = "N";
      }
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover usuário?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.deletar(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};
                this.initialize();
                this.totalLicencas();
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
      this.errors.usuario.email.jaExiste = false;
      this.$v.$reset();
    },

    save() {
      this.$v.$touch()

      if (this.editedItem.id > 0) {
        this.editedItem.repeatPassword = this.editedItem.password;
      }

        if (!this.$v.$invalid) {
          const headers = this.Helpers.iniciarRequisicao();

          const params = this.editedItem;

          this.$store.dispatch(
            "loading/addRequisicao",
            UsuarioAPI.salvar(headers, params)
              .then((response) => {
                const {token, licencasEsgotadas} = response.data;
                localStorage.setItem("token", token);

                this.initialize();
                this.close();
                this.totalLicencas();
                this.dialogAtivaDesativa = false;

                if (licencasEsgotadas) {
                  this.dialogError.ativo = true
                  this.dialogError.mensagem = ['Limite de licenças esgotadas, entre em contato com o suporte.']
                }
              })
              .catch((error) => {
                this.Helpers.logout();
              })
          );
          this.close();
        }
      }
    },
  }
</script>
